import { Checkbox, Col, Form, Input, message, Row, Switch } from "antd";
import React, { useEffect, useState } from "react";
import passwordIcon from "../../../assets/dental-inden/icons/passwordIcon.svg";
import riviewer from "../../../assets/age-assessment/icons/riviewer.svg";
import consultant from "../../../assets/age-assessment/icons/consultant.svg";
import termConditionIcon from "../../../assets/dental-inden/icons/termConditionIcon.svg";
import {
  _userProfileData,
  updatePassword,
} from "../../../components/https/settings/profileSettings";
import { errorRequestHandel } from "../../../helper";
import CustomCard from "../../../dentail-indetifcation/components/d-reusable/CustomCard";
import CustomPrimaryButton from "../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import {
  addConsultantToProject,
  addReviewerToProject,
} from "../../../components/https/age-assessment-apis";
import { _addUserProfileData } from "../../../redux/actions/profileSettingsAction";

const termConditions = `<div class="content-data"><h1 style="text-align:center;margin-bottom:12px">Terms &amp; Conditions</h1><p>Welcome to Dental ID!</p><p>These terms and conditions outline the rules and regulations for the use of Burooj Technology Apps FZ LLC's Website / Apps, located at dentalid.app.</p><p>By accessing this Website / Apps we assume you accept these terms and conditions. Do not continue to use Dental ID if you do not agree to take all of the terms and conditions stated on this page.</p><p>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this Website / Apps and compliant to the Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services, in accordance with and subject to, prevailing law of United Arab Emirates. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.</p><h3>Cookies</h3><p>We employ the use of cookies. By accessing Dental ID, you agreed to use cookies in agreement with the Burooj Technology Apps FZ LLC's Privacy Policy.</p><p>Most interactive Website / Apps use cookies to let us retrieve the user’s details for each visit. Cookies are used by our Website / Apps to enable the functionality of certain areas to make it easier for people visiting our Website / Apps. Some of our affiliate/advertising partners may also use cookies.</p><h3>License</h3><p>Unless otherwise stated, Burooj Technology Apps FZ LLC and/or its licensors own the intellectual property rights for all material on Dental ID. All intellectual property rights are reserved. You may access this from Dental ID for your own personal use subjected to restrictions set in these terms and conditions.</p><p>You must not:</p><ul><li>Republish material from Dental ID</li><li>Sell, rent or sub-license material from Dental ID</li><li>Reproduce, duplicate or copy material from Dental ID</li><li>Redistribute content from Dental ID</li></ul><p>This Agreement shall begin on the date hereof.&nbsp;</p><p>Parts of this Website / Apps offer an opportunity for users to post and exchange opinions and information in certain areas of the Website / Apps. Burooj Technology Apps FZ LLC does not filter, edit, publish or review Comments prior to their presence on the Website / Apps. Comments do not reflect the views and opinions of Burooj Technology Apps FZ LLC,its agents and/or affiliates. Comments reflect the views and opinions of the person who posts their views and opinions. To the extent permitted by applicable laws, Burooj Technology Apps FZ LLC shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this Website / Apps.</p><p>Burooj Technology Apps FZ LLC reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.</p><p>You warrant and represent that:</p><ul><li>You are entitled to post the Comments on our Website / Apps and have all necessary licenses and consents to do so;</li><li>The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;</li><li>The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy</li><li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.</li></ul><p>You hereby grant Burooj Technology Apps FZ LLC a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.</p><h3>Hyperlinking to our Content</h3><p>The following organizations may link to our Website / Apps without prior written approval:</p><ul><li>Government agencies;</li><li>Search engines;</li><li>News organizations;</li><li>Online directory distributors may link to our Website / Apps in the same manner as they hyperlink to the Website / Appss of other listed businesses; and</li><li>System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Website.</li></ul><p>These organizations may link to our home page, to publications or to other Website / Apps information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party’s site.</p><p>We may consider and approve other link requests from the following types of organizations:</p><ul><li>commonly-known consumer and/or business information sources;</li><li>dot.com community sites;</li><li>associations or other groups representing charities;</li><li>online directory distributors;</li><li>internet portals;</li><li>accounting, law and consulting firms; and</li><li>educational institutions and trade associations.</li></ul><p>We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of Burooj Technology Apps FZ LLC; and (d) the link is in the context of general resource information.</p><p>These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party’s site.</p><p>If you are one of the organizations listed in paragraph 2 above and are interested in linking to our Website / Apps, you must inform us by sending an e-mail to Burooj Technology Apps FZ LLC. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website / Apps, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.</p><p>Approved organizations may hyperlink to our Website / Apps as follows:</p><ul><li>By use of our corporate name; or</li><li>By use of the uniform resource locator being linked to; or</li><li>By use of any other description of our Website / Apps being linked to that makes sense within the context and format of content on the linking party’s site.</li></ul><p>No use of Burooj Technology Apps FZ LLC's logo or other artwork will be allowed for linking absent a trademark license agreement.</p><h3>iFrames</h3><p>Without prior approval and written permission, you may not create frames around our Web Pages that alter in any way the visual presentation or appearance of our Website / Apps.</p><h3>Content Liability</h3><p>We shall not be held responsible for any content that appears on your Website / Apps. You agree to protect and defend us against all claims that are rising on your Website / Apps. No link(s) should appear on any Website / Apps that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.</p><h3>Your Privacy</h3><p>Please read Privacy Policy</p><h3>Reservation of Rights</h3><p>We reserve the right to request that you remove all links or any particular link to our Website / Apps. You approve to immediately remove all links to our Website / Apps upon request. We also reserve the right to amend these terms and conditions and it’s linking policy at any time. By continuously linking to our Website / Apps, you agree to be bound to and follow these linking terms and conditions.</p><h3>Removal of links from our Website / Apps</h3><p>If you find any link on our Website / Apps that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.</p><p>We do not ensure that the information on this Website / Apps is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the Website / Apps remains available or that the material on the Website / Apps is kept up to date.</p><h3>Disclaimer</h3><p>To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our Website / Apps and the use of this Website / Apps. Nothing in this disclaimer will:</p><ul><li>limit or exclude our or your liability for death or personal injury;</li><li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li><li>limit any of our or your liabilities in any way that is not permitted under applicable law; or</li><li>exclude any of our or your liabilities that may not be excluded under applicable law.</li></ul><p>The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.</p><p>As long as the Website / Apps and the information and services on the Website / Apps are provided free of charge, we will not be liable for any loss or damage of any nature.</p><p>The information on this report is not intended or implied to be a substitute for routine professional medico-legal assessment and recommendation. All content, including text, graphics, images, and information, contained on or available through this app/website provides an adjunct assessment tool only.&nbsp;</p><p>Results and conclusions of dental identification are based on systematic automation of legitimated examination methods. You are encouraged to validate any information obtained during the use of the Dental iD app with other sources.&nbsp;</p><p>Dental iD is not responsible nor liable for your assessment’s results and conclusions or any other information or services that you provide through this app/website as it depends on the experience and calibration of the examiner.</p></div>`;

const tabs = [
  {
    id: 1,
    icon: riviewer,
    title: "Reviewer",
  },
  {
    id: 4,
    icon: consultant,
    title: "Consultant",
  },
  {
    id: 2,
    icon: passwordIcon,
    title: "Password & Security",
  },
  {
    id: 3,
    icon: termConditionIcon,
    title: "Terms & Conditions",
  },
];
const AgeAssessmentSettings = () => {
  const userdata = useSelector(
    (state) => state.settings_data.profileSettings_data
  );

  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(1);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState({
    isNewRecord: false,
    isRecordAdded: false,
    inAppNotification: false,
    emialNotification: false,
    is_show_signature: false,
    show_consultant: false,
  });
  const [reviewerForm] = Form.useForm();
  const [consultantForm] = Form.useForm();
  const [consultantValues, setConsultantValues] = useState({
    consultant_name: "",
    consultant_email: "",
    consultant_licence: "",
  });
  const [reviewerValues, setReviewerValues] = useState({
    name: "",
    email: "",
    license_number: "",
  });

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await updatePassword(values);
      if (response.status === 200) {
        message.success("Your password has been updated successfully");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };
  const onFinishReviewer = async (values) => {
    try {
      const paylaod = {
        ...reviewerValues,
        is_show_signature: notifications?.is_show_signature,
      };
      setLoading(true);
      const response = await addReviewerToProject({ payload: paylaod });
      if (response.status === 200) {
        message.success("Reviewer has been added successfully");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };
  const onFinishConsutant = async (values) => {
    try {
      const payload = {
        ...consultantValues,
        show_consultant: notifications.show_consultant ? 1 : 0,
      };

      setLoading(true);
      const response = await addConsultantToProject({ payload: payload });
      if (response.status === 200) {
        message.success("Consultant has been added  successfully");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  const renderCaseView = (type) => {
    switch (type) {
      case 1:
        return renderReviewer();
        break;
      case 2:
        return renderPasswordAndSecurity();
        break;

      case 3:
        return renderTermsAndConditions();
        break;

      case 4:
        return renderConsultant();
        break;
      default:
        return renderReviewer();
        break;
    }
  };

  const renderReviewer = () => {
    return (
      <div className="setting_screen_notification_section">
        <p className="_heading">Reviewer</p>

        <div className="setting_screen_toggle_section">
          <div>
            <p>Reviewer Signature</p>
            <span>
              Enabling reviewer signature will add signature of reviewer at the
              end of report
            </span>
          </div>
          <div>
            <Switch
              style={{
                background: notifications.is_show_signature
                  ? "#20C3FF"
                  : "#20C3FF38",
              }}
              checked={notifications.is_show_signature}
              onChange={(e) =>
                setNotifications({
                  ...notifications,
                  is_show_signature: e,
                })
              }
            />
          </div>
        </div>
        <br />
        <Form layout="vertical" onFinish={onFinishReviewer} form={reviewerForm}>
          <div className="d-case_form">
            <Row>
              <Col md={24}>
                <Form.Item label="Full Name">
                  <Input
                    type="text"
                    value={reviewerValues.name}
                    onChange={(e) =>
                      setReviewerValues({
                        ...reviewerValues,
                        name: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
              <Col md={24}>
                <Form.Item label="Email">
                  <Input
                    type="text"
                    value={reviewerValues.email}
                    onChange={(e) =>
                      setReviewerValues({
                        ...reviewerValues,
                        email: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
              <Col md={24}>
                <Form.Item label="License Number">
                  <Input
                    type="text"
                    value={reviewerValues.license_number}
                    onChange={(e) =>
                      setReviewerValues({
                        ...reviewerValues,
                        license_number: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <br />
          <CustomPrimaryButton
            title="Update"
            type={"submit"}
            isLoading={loading}
          />
        </Form>
      </div>
    );
  };
  const renderConsultant = () => {
    return (
      <div className="setting_screen_notification_section">
        <p className="_heading">Consultant</p>

        <div className="setting_screen_toggle_section">
          <div>
            <p>Consultant Signature</p>
            <span>
              Enabling consultant signature will add signature of consultant at
              the end of report
            </span>
          </div>
          <div>
            <Switch
              style={{
                background: notifications.show_consultant
                  ? "#20C3FF"
                  : "#20C3FF38",
              }}
              checked={notifications.show_consultant}
              onChange={(e) =>
                setNotifications({
                  ...notifications,
                  show_consultant: e,
                })
              }
            />
          </div>
        </div>
        <br />
        <Form
          layout="vertical"
          onFinish={onFinishConsutant}
          form={consultantForm}
        >
          <div className="d-case_form">
            <Row>
              <Col md={24}>
                <Form.Item label="Full Name">
                  <Input
                    type="text"
                    value={consultantValues.consultant_name}
                    onChange={(e) =>
                      setConsultantValues({
                        ...consultantValues,
                        consultant_name: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
              <Col md={24}>
                <Form.Item label="Email">
                  <Input
                    type="text"
                    value={consultantValues.consultant_email}
                    onChange={(e) =>
                      setConsultantValues({
                        ...consultantValues,
                        consultant_email: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
              <Col md={24}>
                <Form.Item label="License Number">
                  <Input
                    type="text"
                    value={consultantValues.consultant_licence}
                    onChange={(e) =>
                      setConsultantValues({
                        ...consultantValues,
                        consultant_licence: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <br />
          <CustomPrimaryButton
            title="Update"
            type={"submit"}
            isLoading={loading}
          />
        </Form>
      </div>
    );
  };
  const renderPasswordAndSecurity = () => {
    return (
      <div className="setting_screen_notification_section">
        <p className="_heading">Update Password</p>
        <br />
        <Form layout="vertical" onFinish={onFinish}>
          <Row>
            <Col md={24}>
              <Form.Item
                label="Old Password"
                name={"current_password"}
                rules={[{ required: true, message: "This field is required" }]}
              >
                <Input.Password type="password" style={{ height: "unset" }} />
              </Form.Item>
            </Col>
            <Col md={24}>
              <Form.Item
                label="New Password"
                name={"password"}
                rules={[
                  { required: true, message: "This field is required" },
                  {
                    pattern: /^(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/,
                    message:
                      "Password must be at least 6 characters long and contain at least one special character",
                  },
                ]}
              >
                <Input.Password type="password" />
              </Form.Item>
            </Col>
            <Col md={24}>
              <Form.Item
                label="Confirm Password"
                name={"password_confirmation"}
                dependencies={["password"]}
                rules={[
                  { required: true, message: "This field is required" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password type="password" />
              </Form.Item>
            </Col>
          </Row>
          <br />
          <CustomPrimaryButton
            title="Update"
            type={"submit"}
            isLoading={loading}
          />
        </Form>
      </div>
    );
  };
  const renderTermsAndConditions = () => {
    return (
      <div className="settings_term_condition_container">
        {/* <p className="_heading">Terms & Conditions</p> */}
        <div
          className="settings_html"
          dangerouslySetInnerHTML={{ __html: termConditions }}
        ></div>
      </div>
    );
  };

  useEffect(() => {
    userProfileData();
  }, [selectedTab]);

  const userProfileData = async () => {
    try {
      const response = await _userProfileData();
      if (response.status === 200) {
        dispatch(_addUserProfileData(response.data.data));

        setReviewerValues({
          ...reviewerValues,
          name: response?.data?.data?.reviewer?.name,
          email: response?.data?.data?.reviewer?.email,
          license_number: response?.data?.data?.reviewer?.license_number,
        });
        setConsultantValues({
          ...consultantValues,
          consultant_name: response?.data?.data?.consultant_name,
          consultant_email: response?.data?.data?.consultant_email,
          consultant_licence: response?.data?.data?.consultant_licence,
        });

        setNotifications({
          ...notifications,
          is_show_signature: response.data.data.reviewer?.is_show_signature,
          show_consultant: response.data.data?.show_consultant,
        });
        localStorage.setItem("user", JSON.stringify(response.data.data));
      }
    } catch (error) {
      errorRequestHandel({ error: error });
    }
  };

  return (
    <div className="setting_screen_container">
      <Row gutter={[10, 16]}>
        <Col md={6}>
          <CustomCard>
            <div className="setting_screen_tabs">
              {tabs.map((tab, index) => {
                return (
                  <div
                    className="setting_screen_tab"
                    key={index}
                    onClick={() => setSelectedTab(tab.id)}
                    style={{
                      background:
                        tab.id === selectedTab ? "#20c3ff12" : "transparent",
                    }}
                  >
                    <img src={tab.icon} />
                    <p>{tab.title}</p>
                  </div>
                );
              })}
            </div>
          </CustomCard>
        </Col>
        <Col md={18}>
          <CustomCard>
            <div className="setting_screen_details">
              {renderCaseView(selectedTab)}
            </div>
          </CustomCard>
        </Col>
      </Row>
    </div>
  );
};

export default AgeAssessmentSettings;
